export const statusCode = {
	bad_request: 400,
	unauthorized: 401,
	forbidden: 403,
	not_found: 404,
	internal_server_error: 500
};

export enum PACICode {
	INVALID_USER_PASSWORD = 'ERR-03109',
	PASSWORD_TIMEOUT = 'ERR-00114',
	INVALID_CAPTCHA = 'ERR-XXXXX',
	INVALID_JWT = 'ERR-XXXXX'
}
